// extracted by css-extract-rspack-plugin
export default {"cls1":"RelatedWorksCard-cls1_2E3","cls2":"RelatedWorksCard-cls2_rFo RelatedWorksCard-cls1_2E3"};